import APICall from './../utils/APICall';

export default class InvestmentServices {

    static listInvestments = async (page, pageLimimt, search,from, to, investmentStatus) => {
        return await APICall(`/api/Investment/admin/list-all-investments?page=${page}&pageLimit=${pageLimimt}&search=${search}&from=${from}&to=${to}&investmentStatus=${investmentStatus}`, "GET")
    }
    static updateInvestment = async (payload) => {
        return await APICall(`/api/Investment/admin/update-investment-rate`, "POST", payload)
    }
    static listRates = async (search) => {
        return await APICall(`/api/Investment/admin/list-investment-rates?search=${search}`, "GET")
    }
    static listInvestmentsTypes = async () => {
        return await APICall(`/api/Investment/admin/list-investment-types`, "GET")
    }
    static exportInvestments = async (search,from, to,investmentStatus) => {
        return await APICall(`/api/Investment/admin/export-all-investment?search=${search}&from=${from}&to=${to}&investmentStatus=${investmentStatus}`, "GET")
    }
    static approveInvestment = async (payload) =>{
        return await APICall ("/api/Investment/admin/approve-investment", "POST", payload)
    }
    static rejectInestment = async (payload) =>{
        return await APICall("/api/Investment/admin/reject-investment", "POST", payload)
    }
}
